import request from '@/utils/request'

// 查询列表
export function apiScpMrpWipJobKittingList (query) {
  return request({
    url: '/scp/scpMrpWipJobKitting/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpMrpWipJobKittingNewExport (data) {
  return request({
    url: '/scp/scpMrpWipJobKitting/v2/export',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansKittingExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/kittingExecutionTime',
    method: 'get',
    params: query
  })
}
